import React, { Children, memo } from 'react';
import { ChevronRight, Sparkles, Bath, Brain, Baby, Apple, Zap, Eye, Wheat, Heart, Leaf, Home, Shield, Gem, Pill, Droplet, CircleDot, Sparkle, Dumbbell, Scale, Sprout, Salad, BoxIcon } from 'lucide-react';
type Category = {
  name: string;
  url: string;
  icon: BoxIcon;
};
const categories: Category[] = [{
  name: 'Anti-Aging Vitamins',
  url: 'https://www.bestvitaminsforall.com/bestantiagingvitamins',
  icon: Sparkles
}, {
  name: 'Body Care Products',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-body-care-products.html',
  icon: Bath
}, {
  name: 'Memory Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-brain-memory-supplements.html',
  icon: Brain
}, {
  name: 'Children Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-children-supplements.html',
  icon: Baby
}, {
  name: 'Digestion Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-digestion-supplements.html',
  icon: Apple
}, {
  name: 'Energy Vitamins & Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-energy-vitamins-supplements.html',
  icon: Zap
}, {
  name: 'Eyes & Vision',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-eyes-vision.html',
  icon: Eye
}, {
  name: 'Fiber Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-fiber-supplements.html',
  icon: Wheat
}, {
  name: 'Heart Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-heart-supplements.html',
  icon: Heart
}, {
  name: 'Herbal Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-herbal-supplements.html',
  icon: Leaf
}, {
  name: 'Home Care Products',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-home-care-products.html',
  icon: Home
}, {
  name: 'Immune Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-immune-supplements.html',
  icon: Shield
}, {
  name: 'Mineral Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-mineral-supplements.html',
  icon: Gem
}, {
  name: 'Multi-Vitamins',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-multi-vitamins.html',
  icon: Pill
}, {
  name: 'Natural Oils',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-natural-oils.html',
  icon: Droplet
}, {
  name: 'Single Vitamins',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-single-vitamins.html',
  icon: CircleDot
}, {
  name: 'Skin Care Products',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-skin-care.html',
  icon: Sparkle
}, {
  name: 'Sports Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-sports-supplements.html',
  icon: Dumbbell
}, {
  name: 'Vegan Vitamins & Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-vegan-vitamins-supplements.html',
  icon: Sprout
}, {
  name: 'Vegetarian Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-vegetarian-supplements.html',
  icon: Salad
}, {
  name: 'Weight Loss Supplements',
  url: 'https://www.bestvitaminsforall.com/15m8/gnld-neolife-weight-loss-supplements.html',
  icon: Scale
}, {
  name: 'Protein Shakes',
  url: 'https://www.bestvitaminsforall.com/15m8/neolife-protein-shakes.html',
  icon: BoxIcon
}, {
  name: 'Organic Vitamins',
  url: 'https://www.bestvitaminsforall.com/15m8/organic-vitamins.html',
  icon: Leaf
}];
export function ProductCategories() {
  return <section className="bg-[#f9fafb] py-12 lg:py-16 border-t border-gray-100" data-id="element-232">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-233">
        <div className="flex items-center gap-4 mb-8" data-id="element-234">
          <h2 className="text-xl lg:text-2xl font-bold text-gray-900" data-id="element-235">
            Product Categories
          </h2>
          <div className="h-0.5 bg-[#9fd23d] flex-grow max-w-[80px]" data-id="element-236"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-2" data-id="element-237">
          {categories.map(category => {
          const Icon = category.icon;
          return <a key={category.name} href={category.url} className="flex items-center justify-between py-3 px-4 bg-white rounded border border-gray-100 hover:border-[#0e7be1] transition-colors group" data-id="element-238">
                <div className="flex items-center gap-3" data-id="element-239">
                  <Icon className="h-4 w-4 text-[#0e7be1] flex-shrink-0" data-id="element-240" />
                  <span className="text-sm text-gray-700 group-hover:text-[#0e7be1] transition-colors" data-id="element-241">
                    {category.name}
                  </span>
                </div>
                <ChevronRight className="h-4 w-4 text-gray-300 group-hover:text-[#0e7be1] transition-colors flex-shrink-0" data-id="element-242" />
              </a>;
        })}
        </div>
      </div>
    </section>;
}